/**
 * Analytics.ts — Lightweight self-hosted analytics for Gallowcrest.
 *
 * Sends game events to the ChoiceRealms API. No cookies, no PII, no third-party scripts.
 * Gracefully no-ops on network errors — never disrupts gameplay.
 */

const API_URL = 'https://api.choicerealms.com/api/analytics';
const PAGE = 'gallowcrest';

function track(event: string): void {
  try {
    const payload = JSON.stringify({ page: PAGE, event });
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      navigator.sendBeacon(API_URL, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(API_URL, { method: 'POST', body: payload, headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(() => {});
    }
  } catch {
    // Silently ignore analytics failures — never disrupt gameplay
  }
}

export const analytics = {
  /** Track session start (called once on boot). */
  sessionStart(): void {
    track('pageview');
  },

  /** Track class selection during character creation. */
  classSelection(_className: string): void {
    track('class_selection');
  },

  /** Track chapter progression. */
  chapterProgress(_chapter: number, _act: number): void {
    track('chapter_progress');
  },

  /** Track reaching a game ending. */
  endingReached(_endingId: string, _className: string, _playtimeMs: number, _level: number): void {
    track('ending_reached');
  },

  /** Track achievement unlock. */
  achievement(_achievementId: string): void {
    track('achievement');
  },
} as const;
